

































































import { Component, Vue, Prop } from 'vue-property-decorator';
import DynamicDivider from '@/components/DynamicDivider.vue';
import Verifier from '../scanner/Verifier.vue';

@Component({
  components: {
    DynamicDivider,
    Verifier,
  },
})
export default class CertificateInformation extends Vue {
  @Prop() public certificatePayload!: any;
  @Prop() public isCertificateView!: boolean;
  @Prop() public isRevoked!: boolean;
  @Prop() public clickedPage!: boolean;
  @Prop() public desktop!: boolean;
  @Prop() public merchant!: string;
  get parsed() {
    const {...parsed } = this.certificatePayload.data;
    return parsed;
  }
  get isShow() {
    return this.clickedPage;
  }
  get isDesktop() {
    return this.desktop;
  }

}
